import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { Table } from "antd";
import { Form } from "react-final-form";
import CheckboxField from "@/shared/components/form/CheckboxField";

const RemovalHierarchyDigitalMediaModal = ({
  isOpen,
  toggle,
  deletedHierarchyData,
  checkedState,
  setCheckedState,
  onSubmitDeleteHierarchyList,
}) => {

  const columns = [
    {
      title: "ID",
      dataIndex: "media_type_id",
      key: "media_type_id",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Name",
      dataIndex: "media_type",
      key: "media_type",
    },
    {
      title: "Program ID",
      dataIndex: "program_id",
      key: "program_id",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Program Name",
      dataIndex: "program_name",
      key: "program_name",
    },
    {
      title: "Delete?",
      key: "action",
      render: (_, record, index) => (
        <div className="checkbox-custom2">
          <CheckboxField
            name={`action-checkbox-${record.media_type_id}`}
            checked={checkedState[index].checked}
            onChange={() => {
              const updated = [...checkedState];
              updated[index].checked = !updated[index].checked;
              setCheckedState(updated);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <Modal
      className="modal-media-hierarchy-list modal-lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <ModalHeader>
        <div>
          Please select the programs that you wish to update or add this digital media to
        </div>
      </ModalHeader>

      <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
        <Form onSubmit={onSubmitDeleteHierarchyList}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div style={{}}>
                <Button
                  outline
                  className="btn btn-primary btn-sm"
                  color="#ffffff"
                >
                  Delete
                </Button>
              </div>

              <Table
                pagination={false}
                rowKey="id"
                columns={columns}
                dataSource={deletedHierarchyData}
              />
            </form>
          )}
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default RemovalHierarchyDigitalMediaModal;
